import { ActionTypesFactory } from "./ActionTypesFactory";

const userInfoActionsTypes = ActionTypesFactory.crudActionTypes("USER_INFO");

export default userInfoActionsTypes;
